var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1017,
    height: 101,
    viewBox: "0 0 1017 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_64403)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.398438,
    width: 1016,
    height: 100,
    rx: 12,
    fill: "url(#paint0_linear_245_64403)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.662 25.5088C138.662 25.4719 138.663 25.4353 138.663 25.3985C138.663 5.38592 122.563 -10.8374 102.703 -10.8374C87.9775 -10.8374 75.3215 -1.91731 69.7605 10.8517C68.3499 10.607 66.9003 10.4779 65.4205 10.4779C51.4014 10.4779 40.0366 21.9297 40.0366 36.0561C40.0366 50.1825 51.4014 61.6343 65.4205 61.6343H140.647C150.577 61.6343 158.627 53.5225 158.627 43.5162C158.627 33.51 150.577 25.3985 140.647 25.3985C139.976 25.3985 139.314 25.4367 138.662 25.5088Z",
    fill: "url(#paint1_linear_245_64403)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M960.32 78.8917C960.32 78.8365 960.322 78.7817 960.322 78.7264C960.322 48.7249 936.186 24.4039 906.412 24.4039C884.337 24.4039 865.364 37.7764 857.027 56.9188C854.913 56.5519 852.74 56.3585 850.521 56.3585C829.505 56.3585 812.467 73.5263 812.467 94.7037C812.467 115.881 829.505 133.049 850.521 133.049H963.295C978.182 133.049 990.25 120.888 990.25 105.887C990.25 90.8866 978.182 78.7264 963.295 78.7264C962.29 78.7264 961.297 78.7837 960.32 78.8917Z",
    fill: "url(#paint2_linear_245_64403)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.036,
    y: 16.2701,
    width: 91.8061,
    height: 176.257,
    rx: 13.2124,
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.817265
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.859,
    y: 16.5425,
    width: 91.2612,
    height: 175.712,
    rx: 12.94,
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 1.36211
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.64,
    y: 21.7184,
    width: 25.0628,
    height: 7.35538,
    rx: 3.67769,
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.817265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.49,
    cy: 67.0363,
    r: 18.605,
    fill: "#BFEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.517 68.6658L177.417 74.1239L189.35 60.8346",
    stroke: "#292B2E",
    strokeWidth: 0.885952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_64403",
    x1: 0.25,
    y1: 0.398437,
    x2: 3.31681,
    y2: 125.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_64403",
    x1: 99.3317,
    y1: 38.8484,
    x2: 95.0354,
    y2: 7.72498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_64403",
    x1: 901.359,
    y1: 98.8897,
    x2: 894.918,
    y2: 52.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_64403"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.398438,
    width: 1016,
    height: 100,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosPending);
export default __webpack_public_path__ + "static/media/IosPending.867d5f6b100962ace596115f288ac79e.svg";
export { ForwardRef as ReactComponent };